import p from "preact";

const LinkedIn = ({ color = "#788391" }) => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-851.000000, -535.000000)" fill={color}>
          <path d="M851,551 C851,542.163444 858.163444,535 867,535 C875.836556,535 883,542.163444 883,551 C883,559.836556 875.836556,567 867,567 C858.163444,567 851,559.836556 851,551 Z M862.307028,548.251899 L858.681078,548.251899 L858.681078,559.146373 L862.307028,559.146373 L862.307028,548.251899 Z M862.545842,544.881798 C862.522308,543.813602 861.758436,543 860.518021,543 C859.277607,543 858.466667,543.813602 858.466667,544.881798 C858.466667,545.927869 859.253638,546.764898 860.470954,546.764898 L860.494125,546.764898 C861.758436,546.764898 862.545842,545.927869 862.545842,544.881798 Z M875.38359,552.899815 C875.38359,549.553503 873.594801,547.996076 871.208759,547.996076 C869.283618,547.996076 868.4217,549.053498 867.940451,549.795299 L867.940451,548.252188 L864.314067,548.252188 C864.361858,549.274469 864.314067,559.146662 864.314067,559.146662 L867.940451,559.146662 L867.940451,553.062289 C867.940451,552.736689 867.963985,552.411885 868.059858,552.178766 C868.321916,551.528289 868.91859,550.854818 869.920335,550.854818 C871.232944,550.854818 871.757641,551.853817 871.757641,553.317823 L871.757641,559.146373 L875.383446,559.146373 L875.38359,552.899815 Z" />
        </g>
      </g>
    </svg>
  );
};
export default LinkedIn;



// WEBPACK FOOTER //
// ./assets/icons/LinkedIn.js